<div class="commonBody background" >
  <div fxLayout="row">
    <div fxLayout="column" fxFlex="10"></div>
    <div fxLayout="column" fxFlex="80">
        <div fxLayout="row"style="height: 10vh"></div>
          <div fxLayout="row" class="mat-headline-3">
            <b>Book a Discussion</b>
          </div>
          <div fxLayout="row" class="mat-h1">
            Discuss your requirements and automation needs directly with Michaes, the CoFounder of Jivrus Technologies
          </div>
          <!-- <mat-card class="iframeCard" fxFlex="100%"> -->
           <iframe #iframe id="formIFrame" 
           [src]="sanitizedUrl" 
             height="600px" width="100%" type='text/html'
            style="z-index: 0;" frameBorder="0"></iframe>
          <!-- </mat-card> -->
          <div fxLayout="row"style="height: 20vh"></div>
    </div>
    <div fxLayout="column" fxFlex="10"></div>
  </div>
</div>
